import { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Screen } from "@/components/kit";
import { useLang } from "@/lib/i18n";
import { useSession } from "@/context/SessionContext";
import { measureTank, RISER } from "@/lib/measure";
import { MeasureInputs } from "@/components/measure/MeasureInputs";
import { MeasureResult } from "@/components/measure/MeasureResult";

const KEY = "fhp-measure";
const saved = () => { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch { return {}; } };

export default function MeasurePage() {
  const { t } = useLang();
  const { patch } = useSession();
  const nav = useNavigate();
  const [m, setM] = useState(() => ({ bottomIn: 120, riserIn: RISER.typical, spacingFt: 0, ends: "dome", ...saved() }));
  const set = (p) => setM((o) => { const n = { ...o, ...p }; try { localStorage.setItem(KEY, JSON.stringify(n)); } catch { /* private mode */ } return n; });
  const r = useMemo(() => measureTank(m), [m]);
  const use = (x) => { patch({ capacity: x.capacity, diameter: x.diameter, ends: x.ends }); nav("/drop"); };
  return (
    <Screen testID="measure-screen" title={t("Measure an unknown tank")} subtitle={t("No chart, no label? Get the size from two measurements.")}>
      <MeasureInputs m={m} set={set} t={t} />
      <MeasureResult r={r} onUse={use} t={t} />
    </Screen>
  );
}
